function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import styles from './Switch.pcss';
var _React_PureComponent;
class Switch extends (_React_PureComponent = React.PureComponent) {
    renderLabel() {
        const { labelMessage, labelMessageValues } = this.props;
        if (!labelMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: styles.switch__label,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, labelMessage), {
                values: labelMessageValues
            }))
        });
    }
    /* eslint-disable jsx-a11y/control-has-associated-label */ render() {
        const { isActive, onClick, isDisabled } = this.props;
        const onBtnClick = isDisabled ? undefined : onClick;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.switch__container,
            children: [
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: cn(styles.switch, {
                        [styles['switch--on']]: isActive,
                        [styles['switch--disabled']]: isDisabled
                    }),
                    onClick: onBtnClick,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.switch__cursor, {
                            [styles['switch__cursor--on']]: isActive,
                            [styles['switch__cursor--disabled']]: isDisabled
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: styles.switch__label,
                    children: this.renderLabel()
                })
            ]
        });
    }
}
_define_property(Switch, "propTypes", {
    // Explicit props
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    labelMessageValues: PropTypes.object,
    isDisabled: PropTypes.bool
});
export default withStyles(styles)(Switch);
